import { useQuery } from 'react-query';

export const useSuspense = ({
  refreshOnParameters = [],
  refreshSuspenseMilliseconds = 50,
}) => {
  return useQuery({
    queryKey: ['/suspense'].concat(refreshOnParameters),
    queryFn: () => new Promise(resolve => setTimeout(resolve, refreshSuspenseMilliseconds)),
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};

export default useSuspense;
